import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class DataStore {
  private cbU = new BehaviorSubject<string>("");
  currentBaseUrl$ = this.cbU.asObservable();
  constructor() { }

 updateBaseUrl(baseUrl: string) {
   this.cbU.next(baseUrl)
 }



}
